/* Au Delà des Fleurs — animations légères au défilement (voir assets/adf-motion.css).
   Ne fait rien si <html> n'a pas la classe .adf-motion (réglage coupé, éditeur de thème,
   appareil qui demande moins d'animations).
   Règle d'or : ce qui est déjà à l'écran quand le script démarre n'est jamais caché. */
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('adf-motion')) return;
  if (!('IntersectionObserver' in window)) { html.classList.remove('adf-motion'); return; }

  /* Ce qui s'anime, page par page, et avec quel geste.
     rise = monte en douceur · print = tirage photo posé · sheet = feuille glissée sur la table
     swing = étiquette kraft qui se balance · ink = dessin à l'encre · write = ligne écrite au stylo
     map = carte du Bassin (villes, coccinelle, trajet) */
  var GROUPS = [
    // Titres de section et colonnes de texte (tout le site)
    ['rise', '.adf-head, .adf-story__text, .adf-deliv__text, .adf-faq__side, .adf-press__text, .adf-xmas__text, .adf-ribbon__text, ' +
             '.adf-rev__score, .adf-cabout__text, .adf-pdx__about, .adf-dlocal__text, .adf-cshop__head, .adf-cshop__aside, .adf-cta .adf-wrap, ' +
             '.adf-pdx__cities, .adf-dlocal__also, .adf-budget__label, .adf-visit__map, .adf-404__find, .adf-art__foot, .adf-bempty, .adf-cgrid__empty, ' +
             '.adf-cartp__addons, .adf-lcol__group > .adf-head'],
    // Cartes et listes : elles arrivent l'une après l'autre
    ['rise', '.adf-prod__grid > *, .adf-occ__grid > *, .adf-cshop__prods > *, .adf-blist__grid > *, .adf-val__item, .adf-chap__item, ' +
             '.adf-guide__item, .adf-deliv__list > li, .adf-faq__item, .adf-sres__item, .adf-pdx__step, .adf-ribbon__item, .adf-subnav__item'],
    // Tirages photo scotchés et cartes d'avis
    ['print', '.adf-story__pic, .adf-press__clip, .adf-xmas__photo, .adf-dlocal__print, .adf-snone__print, .adf-rev__card'],
    // Feuilles de papier : bon de commande, carte message, carnet de tournée, fiches
    ['sheet', '.adf-order, .adf-card-note, .adf-route-sheet, .adf-dinfo .adf-pdp__fiche, .adf-guide__note, .adf-cabout__side, ' +
              '.adf-art__ask, .adf-visit__card, .adf-pdx__how'],
    // Étiquettes kraft au bout de leur ficelle
    ['swing', '.adf-budget__list > li, .adf-cshop__chips > li, .adf-xmas__steps > li, .adf-dinfo__steps > li, .adf-pdx__tip, .adf-tools__budgets > li'],
    // Croquis à l'encre
    ['ink', '.adf-sketch__svg, .adf-sz__sketch, .adf-lake__view'],
    // Carnet de tournée : chaque ligne s'écrit
    ['write', '.adf-route-sheet__rows > div'],
    // Carte du Bassin
    ['map', '.adf-map']
  ];
  var ALL = GROUPS.map(function (g) { return g[1]; }).join(', ');
  // Deuil : du calme (fondu seulement)
  var SOBER = '.adf-tpl-deuil, [class*="--sober"], .is-sober';
  var CALM_OK = { map: 1, write: 1, ink: 1 };

  var io = new IntersectionObserver(function (entries) {
    var shown = [];
    entries.forEach(function (e) { if (e.isIntersecting) shown.push(e.target); });
    shown.sort(order);
    shown.forEach(function (el, i) {
      el.style.setProperty('--rv-i', Math.min(i, 7));
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function order(a, b) { return a === b ? 0 : (a.compareDocumentPosition(b) & 4 ? -1 : 1); }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || html.clientHeight);
  }

  // Rangée qui défile de côté (mobile) : ce qui est hors de la rangée ne « croise » jamais l'écran
  function hiddenSideways(el) {
    var p = el.parentElement;
    for (var k = 0; p && k < 3; k++, p = p.parentElement) {
      var ox = getComputedStyle(p).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 1) {
        var r = el.getBoundingClientRect(), pr = p.getBoundingClientRect();
        return r.left >= pr.right - 1 || r.right <= pr.left + 1;
      }
    }
    return false;
  }

  function typeOf(el) {
    for (var i = 0; i < GROUPS.length; i++) if (el.matches(GROUPS[i][1])) return GROUPS[i][0];
    return 'rise';
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    var found = [];
    if (root.matches(ALL)) found.push(root);
    Array.prototype.push.apply(found, root.querySelectorAll(ALL));
    found.sort(order);
    found.forEach(function (el) {
      if (el.hasAttribute('data-rv') || el.closest('.adf-chrome, .shopify-section-group-header-group, .shopify-section-group-footer-group')) return;
      // Un seul geste à la fois : rien à l'intérieur d'un bloc qui s'anime déjà
      if (el.parentElement && el.parentElement.closest('[data-rv]')) return;
      // Déjà visible au chargement : on laisse tel quel (jamais de clignotement)
      if (onScreen(el) || hiddenSideways(el)) { el.setAttribute('data-rv-seen', ''); return; }
      var t = typeOf(el);
      if (!CALM_OK[t] && el.closest(SOBER)) t = 'fade';
      el.setAttribute('data-rv', t);
      io.observe(el);
    });
  }

  function start() {
    var main = document.getElementById('MainContent') || document.body;
    scan(main);

    // Contenus ajoutés plus tard (suggestions de produits, éditeur…) : même traitement
    var queue = [], planned = false;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) queue.push(n); }); });
      if (!planned && queue.length) {
        planned = true;
        requestAnimationFrame(function () { planned = false; var q = queue; queue = []; q.forEach(function (n) { if (n.isConnected) { scan(n); window.adfArmScenes(n); } }); });
      }
    }).observe(main, { childList: true, subtree: true });

    // Pastille du panier : un petit saut à chaque ajout
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      new MutationObserver(function () {
        var c = bubble.querySelector('.adf-cart-count');
        if (!c) return;
        c.classList.remove('adf-bump'); void c.offsetWidth; c.classList.add('adf-bump');
      }).observe(bubble, { childList: true });
    }
  }

  // ---------- Scènes dessinées (snippets/adf-scene.liquid) : jouées une fois, quand elles arrivent à l'écran ----------
  function sceneDone(el) {
    el.classList.add('is-done');
    var v = el.closest('.adf-404__visual'); if (v) v.classList.add('is-stamped');
  }
  function playScene(el) {
    if (el.classList.contains('is-playing')) return;
    el.classList.add('is-playing');
    var key = 'adf-scene-' + el.getAttribute('data-adf-scene'), seen = false;
    try { seen = !!sessionStorage.getItem(key); sessionStorage.setItem(key, '1'); } catch (e) {}
    var svg = el.querySelector('svg');
    // Déjà vue pendant cette visite : on montre directement la dernière image
    if (seen || !svg) { sceneDone(el); return; }
    svg.querySelectorAll('animate, animateTransform').forEach(function (a) { try { a.beginElement(); } catch (e) {} });
    if (el.hasAttribute('data-jumps')) jumpPath(el);
    setTimeout(function () { sceneDone(el); }, (parseFloat(el.getAttribute('data-dur')) || 3) * 1000);
  }
  // Parcours : sauts de tampon en tampon (arcs calculés d'après la place réelle des tampons)
  function jumpPath(el) {
    var list = el.closest('.adf-chap__list'); if (!list || !el.animate) return;
    var marks = list.querySelectorAll('.adf-chap__item .adf-chap__mark span'); if (marks.length < 3) return;
    var dur = parseFloat(el.getAttribute('data-dur')) * 1000;
    var jumps = el.getAttribute('data-jumps').split(';').map(function (j) { return j.split(',').map(parseFloat); });
    var me = el.getBoundingClientRect();
    var feet = { x: me.left + me.width * .44, y: me.bottom - me.height * (6 / 92) };
    function top(m, f) { var r = m.getBoundingClientRect(); return { x: r.left + r.width * f - feet.x, y: r.top + 3 - feet.y }; }
    // il atterrit exactement à sa place figée (sur « Aujourd'hui ») : la fin de l'animation = l'image sans animations
    var pts = [top(marks[0], .5), top(marks[1], .5), { x: 0, y: 0 }];
    var k = [{ offset: 0, transform: 'translate(' + pts[0].x + 'px,' + pts[0].y + 'px)' }];
    jumps.forEach(function (j, i) {
      var a = pts[i], b = pts[i + 1], h = 9 + Math.abs(b.x - a.x) * .01, n = 12;
      k.push({ offset: j[0] * 1000 / dur, transform: 'translate(' + a.x + 'px,' + a.y + 'px)' });
      for (var s = 1; s <= n; s++) {
        var t = s / n, x = a.x + (b.x - a.x) * t, y = a.y + (b.y - a.y) * t - h * 4 * t * (1 - t);
        k.push({ offset: (j[0] + (j[1] - j[0]) * t) * 1000 / dur, transform: 'translate(' + x + 'px,' + y + 'px)' });
      }
    });
    var last = pts[pts.length - 1];
    k.push({ offset: 1, transform: 'translate(' + last.x + 'px,' + last.y + 'px)' });
    el.animate(k, { duration: dur, fill: 'forwards' });
  }
  var sio = null, t0 = Date.now();
  function armScene(el) {
    if (el.classList.contains('is-armed')) return;
    el.classList.add('is-armed');
    var v = el.closest('.adf-404__visual'); if (v) v.classList.add('is-armed');
    sio.observe(el);
  }
  window.adfArmScenes = function (root) { if (sio && root && root.querySelectorAll) { if (root.matches && root.matches('[data-adf-scene]')) armScene(root); root.querySelectorAll('[data-adf-scene]').forEach(armScene); } };
  function startScenes() {
    sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        sio.unobserve(e.target);
        // à l'arrivée sur la page, on laisse d'abord le haut se poser
        var wait = parseInt(e.target.getAttribute('data-delay') || '250', 10);
        setTimeout(function () { playScene(e.target); }, Date.now() - t0 < 1200 ? Math.max(900, wait) : wait);
      });
    }, { threshold: .45 });
    document.querySelectorAll('[data-adf-scene]').forEach(armScene);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startScenes); else startScenes();

  // L'entrée de page (CSS) ne vaut que pour l'arrivée : ensuite, rien ne se rejoue quand une zone est redessinée
  setTimeout(function () { html.classList.add('adf-motion-done'); }, 4500);
})();
